import { useQuery } from "@tanstack/react-query"
import type { FormMenuItemsResponse } from "@/shared/api/types/FormMenuItemsResponse"
import { useCmApi } from "@/shared/hooks/useCmApi"

const QUERY_KEY = "formMenuItems"

export const useGetFormMenuItems = (enabled?: boolean, customerId?: string) => {
  const cmApi = useCmApi()
  const { data, isLoading, isError } = useQuery<FormMenuItemsResponse>({
    queryKey: [QUERY_KEY, customerId],
    queryFn: () => cmApi.getFormMenuItems(customerId),
    placeholderData: (prev?: FormMenuItemsResponse) => prev,
    enabled
  })
  return { data, isLoading, isError }
}
